import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const workflowImporterSelectors = importerSelectors(
  'workflow.importer',
);

export default workflowImporterSelectors;
